import getResyncDataRequest from '@domain/model/request/selloutMonitoring/getResyncDataRequest';
import getResyncData from '@hooks/selloutMonitoring/getResyncData';

const useGetResyncData = (filters) => {
    const queries = getResyncDataRequest(filters);
    return getResyncData(queries);
};

export default useGetResyncData;
